import localforage from 'localforage'

let localforageStoreVehicleTypes = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'vehicle-types'
})

const initialState = {
  all: [],
  vehicleType: {
    id: null,
    text: null
  }
}

let state = initialState

const getters = {
  getAllVehicleTypes: state => state.all,
  getVehicleType: state => state.vehicleType
}

const actions = {
  importVehicleTypes ({ commit }, vehicleTypes) {
    return new Promise((resolve, reject) => {
      commit('clearVehicleTypesState')
      vehicleTypes.forEach((vehicleType) => {
        localforageStoreVehicleTypes.setItem(String(vehicleType.id).trim(), JSON.stringify(vehicleType)) // attention: vehicle type ids are delivered as strings by api
      })
      commit('setVehicleTypesToState', vehicleTypes)
      resolve()
    })
  },
  loadAllVehicleTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      let vehicleTypes = []
      return localforageStoreVehicleTypes.iterate(function (value) {
        vehicleTypes.push(JSON.parse(value))
      }).then(function () {
        commit('setVehicleTypesToState', vehicleTypes)
        resolve()
      })
    })
  },
  clearVehicleTypesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreVehicleTypes.clear().then(() => {
        commit('clearVehicleTypesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setVehicleTypesToState (state, vehicleTypes) {
    state.all = vehicleTypes
  },
  clearVehicleTypesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/vehicleTypes.js